import { render, staticRenderFns } from "./salesOrderStatus.vue?vue&type=template&id=1d94ffa5&"
import script from "./salesOrderStatus.vue?vue&type=script&lang=js&"
export * from "./salesOrderStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports